export const SHORT_HAND_RATE_FORMAT = 'ShortHand';
export const LONG_HAND_RATE_FORMAT = 'LongHand';
